/**
 * @generated SignedSource<<767359e6669bc39b01f0d65f3bdc6fb4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_issueResults$data = {
  readonly __id: string;
  readonly pageCursors: {
    readonly around: ReadonlyArray<{
      readonly isCurrent: boolean | null | undefined;
      readonly pageNumber: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions" | "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber" | "ui_nativeIssueTable_NativeIssueTable_issues">;
  readonly " $fragmentType": "main_issueNavigator_ListView_issueResults";
};
export type main_issueNavigator_ListView_issueResults$key = {
  readonly " $data"?: main_issueNavigator_ListView_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_issueResults",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        {
          "kind": "Variable",
          "name": "shouldQueryHasChildren",
          "variableName": "shouldQueryHasChildren"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ui_nativeIssueTable_NativeIssueTable_issues"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "maxCursors",
          "value": 7
        }
      ],
      "concreteType": "JiraPageCursors",
      "kind": "LinkedField",
      "name": "pageCursors",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraPageCursor",
          "kind": "LinkedField",
          "name": "around",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "pageNumber"
            },
            {
              "kind": "ScalarField",
              "name": "isCurrent"
            }
          ]
        }
      ],
      "storageKey": "pageCursors(maxCursors:7)"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "e299d6f876a205657de6472b7a94390c";

export default node;
